<div id="mrp-container" class="layout-container">
    <app-header id="mrp-header" class="layout-header"></app-header>
    <div id="mrp-body" class="layout-body">
        <router-outlet></router-outlet>
        <app-footer id="mrp-footer" *ngIf="!CheckRoutersName()"></app-footer>
    </div>
</div>
